import { MEDIA_QUERIES } from '@student-coin/coinpaper-components';
import styled from 'styled-components';

export const Container = styled.div`
  margin-bottom: 16px;
  @media (${MEDIA_QUERIES.laptopL}) {
    margin-bottom: 4px;
  }
  @media (${MEDIA_QUERIES.desktopL}) {
    margin-bottom: 16px;
  }
`;

export const Heading = styled.span`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 600;
  @media (${MEDIA_QUERIES.laptopL}) {
    font-size: 13px;
  }
  @media (${MEDIA_QUERIES.desktopL}) {
    font-size: 14px;
  }
`;
